<template>
  <el-dialog title="Nova Visita" @open="reset" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="40%">
    <el-form size="small" label-position="top" style="margin: -20px 0px 0px 0px">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Data">
            <el-input v-model="visita.data" v-mask="'##/##/####'"/>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="form-item" label="Hora">
            <el-input v-model="visita.hora" v-mask="'##:##'"></el-input> 
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="Cliente" style="width: 100%">
            <el-input :value="this.cliente.nome" readonly/>
          </el-form-item>
        </el-col>
      </el-row>      

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Atendente" style="width: 100%">
            <el-select
              v-model="visita.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              value-key="id"
              placeholder=""
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      

      <el-row :gutter="10" style="padding: 0px 0px;">
        <el-col :span="19">
          <el-form-item label="Adicionar Imóvel">
            <el-select v-model="auxImovel"
              :remote-method="recuperarImoveisSelect"
              :loading="loadingImoveis"
              value-key="id"
              placeholder=""
              loading-text="Carregando imóvei"
              no-data-text="Nenhum imóvel encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%">
              <el-option
                v-for="item in imoveisDisponiveis"
                :key="item.id"
                :label="item.endereco"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="5">
          <el-form-item label=" " style="width: 100%">
            <el-button @click.native.prevent="adicionarImovelSelecionado()" type="success" size="small" style="width: 100%">Adicionar</el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row style="height: 40%; padding: 10px 0px;">
        <el-col :span="24" style="height: 100%">
          <el-container style="height: 100%">
            <el-main style="padding: 0px; height: 100%">
              <el-table
                :data="this.imoveisSelecionados" 
                empty-text="Nenhum imóvel selecionado"
                width="100%"
                max-height="250"
                size="small"
                style="background-color: #FFFFFF; border: solid 1px #DBDFE5; border-radius: 5px;"
                stripe
                highlight-current-row>
                <el-table-column label="Endereço" width="250" prop="endereco"/>
                <el-table-column label="Número" width="90" prop="numeroEndereco"/>
                <el-table-column>
                  <template slot-scope="scope">
                    <el-button 
                      @click.native.prevent="removerImovelSelecionado(scope.row)"
                      type="text" 
                      size="small" 
                      style="padding: 0px; color: #F56C6C;">Remover</el-button>
                  </template>
                </el-table-column> 
              </el-table>
            </el-main>
          </el-container>
        </el-col>
      </el-row>
      
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Descrição">
            <el-input rows="2" type="textarea" v-model="visita.descricao"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravar" type="primary" size="small">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';

import URLS from '../../util/urls.js';

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      loadingImoveis: false,
      loadingUsuarios: false,

      visita: {
        data: "",
        hora: "",
        descricao: "",
        imovel: {
          id: 0
        },
        usuario: {}
      },
      auxImovel: {},
      imoveisSelecionados: [],
      imoveisDisponiveis: []
    }
  },  
  computed: {
    ...mapState('clientesStore', {
      cliente(state) { return state.clienteSelecionado },
      usuariosDisponiveis(state) { return state.usuariosDisponiveis }
      })
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
  ...mapActions('clientesStore', [
      'listarUsuarios',
      'gravarVisita'
    ]),
    reset() {
      this.visita = {
        data: "",
        hora: "",
        descricao: "",
        usuario: {}
      }
    },
    limparVisita() {
      this.visita.data =  "",
      this.visita.hora = "",
      this.visita.descricao = "",
      this.visita.imovel = { id : 0 },
      this.visita.usuario = {}
      this.imoveisSelecionados = []
    },
    gravar() {
      let auxVisita = {};
      auxVisita.dataHora = this.visita.data + " " + this.visita.hora;
      auxVisita.descricao = this.visita.descricao;
      auxVisita.imoveis = this.imoveisSelecionados;
      auxVisita.imovel = this.visita.imovel;
      auxVisita.cliente = { id: this.cliente.id };
      auxVisita.usuario = this.visita.usuario;
      this.showLoading();

      this.gravarVisita(auxVisita)
      .then((resultado) => {
        this.hideLoading();        
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            this.fechar();
            break;
        }
      }).catch(() => {
        this.hideLoading();
      })
    },
    recuperarImoveisSelect(queryString) {
      let payload = { endereco: queryString }
      this.loadingImoveis = true;

      axios.post(URLS.IMOVEIS_LISTAR, payload)
      .then((response) => {
        this.imoveisDisponiveis = response.data.lista;
        this.loadingImoveis = false;
      }).catch(() => {
        this.imoveisDisponiveis = [];
        this.loadingImoveis = false;
      });
    },
    filtrarUsuariosSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      })
      },    
    adicionarImovelSelecionado(){
      this.imoveisSelecionados.push(this.auxImovel);
    },
    removerImovelSelecionado(imovel) {
      var i;
      for(i=0;i<this.imoveisSelecionados.length;i++){
        if(this.imoveisSelecionados[i].id == imovel.id){
          this.imoveisSelecionados.splice(i, 1);
        }
      }
    },
    fechar() {
      this.limparVisita();
      this.$emit('close');
    }
  }
}
</script>

